/**
@flow strict-local
@format
*/
import Link from './Link';

export default Link;
